//#region src/gql/graphql.ts
var MyPendingInviteListFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "MyPendingInviteListFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "OrganizationInvitationsConnection"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "edges"
				},
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "node"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "organization"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "role"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "status"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "createdAt"
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
var PricingCardFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "PricingCardFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "ApiSubscriptionPlan"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "description"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "name"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "prices"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "amountCents"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "currency"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "stripePriceId"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "recurring"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "interval"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "intervalCount"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "trialPeriodDays"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "billingScheme"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "__typename"
														}
													},
													{
														"kind": "InlineFragment",
														"typeCondition": {
															"kind": "NamedType",
															"name": {
																"kind": "Name",
																"value": "ApiSubscriptionPlanPriceBillingSchemePerUnit"
															}
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "__typename"
																}
															}, {
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "usageType"
																}
															}]
														}
													},
													{
														"kind": "InlineFragment",
														"typeCondition": {
															"kind": "NamedType",
															"name": {
																"kind": "Name",
																"value": "ApiSubscriptionPlanPriceBillingSchemeTiered"
															}
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "__typename"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "tiersMode"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "tiers"
																	},
																	"selectionSet": {
																		"kind": "SelectionSet",
																		"selections": [
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "__typename"
																				}
																			},
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "flatAmountCents"
																				}
																			},
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "unitAmountCents"
																				}
																			},
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "upTo"
																				}
																			}
																		]
																	}
																}
															]
														}
													}
												]
											}
										}
									]
								}
							}
						]
					}
				}
			]
		}
	}]
};
var PricingTableFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "PricingTableFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "ApiSubscriptionPlanResult"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "plans"
				},
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "description"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "name"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "prices"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								}, {
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								}]
							}
						},
						{
							"kind": "FragmentSpread",
							"name": {
								"kind": "Name",
								"value": "PricingCardFragment"
							}
						}
					]
				}
			}]
		}
	}, {
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "PricingCardFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "ApiSubscriptionPlan"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "description"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "name"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "prices"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "amountCents"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "currency"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "stripePriceId"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "recurring"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "interval"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "intervalCount"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "trialPeriodDays"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "billingScheme"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [
													{
														"kind": "Field",
														"name": {
															"kind": "Name",
															"value": "__typename"
														}
													},
													{
														"kind": "InlineFragment",
														"typeCondition": {
															"kind": "NamedType",
															"name": {
																"kind": "Name",
																"value": "ApiSubscriptionPlanPriceBillingSchemePerUnit"
															}
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "__typename"
																}
															}, {
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "usageType"
																}
															}]
														}
													},
													{
														"kind": "InlineFragment",
														"typeCondition": {
															"kind": "NamedType",
															"name": {
																"kind": "Name",
																"value": "ApiSubscriptionPlanPriceBillingSchemeTiered"
															}
														},
														"selectionSet": {
															"kind": "SelectionSet",
															"selections": [
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "__typename"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "tiersMode"
																	}
																},
																{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "tiers"
																	},
																	"selectionSet": {
																		"kind": "SelectionSet",
																		"selections": [
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "__typename"
																				}
																			},
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "flatAmountCents"
																				}
																			},
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "unitAmountCents"
																				}
																			},
																			{
																				"kind": "Field",
																				"name": {
																					"kind": "Name",
																					"value": "upTo"
																				}
																			}
																		]
																	}
																}
															]
														}
													}
												]
											}
										}
									]
								}
							}
						]
					}
				}
			]
		}
	}]
};
var OrganizationNameFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "OrganizationNameFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "Organizations"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "id"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "name"
					}
				}
			]
		}
	}]
};
var OrganizationMemberFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "OrganizationMemberFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "OrganizationMembers"
			}
		},
		"directives": [{
			"kind": "Directive",
			"name": {
				"kind": "Name",
				"value": "_unmask"
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "id"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "role"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "profileId"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "profile"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "email"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "avatarUrl"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "name"
								}
							}
						]
					}
				}
			]
		}
	}]
};
var OrganizationMemberListFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "OrganizationMemberListFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "Organizations"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "id"
					}
				},
				{
					"kind": "Field",
					"alias": {
						"kind": "Name",
						"value": "members"
					},
					"name": {
						"kind": "Name",
						"value": "organizationMembersCollection"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						}, {
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "edges"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								}, {
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "node"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "profileId"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "role"
												}
											},
											{
												"kind": "FragmentSpread",
												"name": {
													"kind": "Name",
													"value": "OrganizationMemberFragment"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}
			]
		}
	}, {
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "OrganizationMemberFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "OrganizationMembers"
			}
		},
		"directives": [{
			"kind": "Directive",
			"name": {
				"kind": "Name",
				"value": "_unmask"
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "id"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "role"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "profileId"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "profile"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "email"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "avatarUrl"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "name"
								}
							}
						]
					}
				}
			]
		}
	}]
};
var OrganizationInviteListFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "OrganizationInviteListFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "Organizations"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "id"
					}
				},
				{
					"kind": "Field",
					"alias": {
						"kind": "Name",
						"value": "invites"
					},
					"name": {
						"kind": "Name",
						"value": "organizationInvitationsCollection"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						}, {
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "edges"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								}, {
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "node"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "createdAt"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "role"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "status"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "email"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "invitationOwnerProfile"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "__typename"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "id"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "email"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "name"
															}
														}
													]
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "invitedProfile"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "__typename"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "id"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "email"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "name"
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}
			]
		}
	}]
};
var OrganizationPageFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationPageFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "FragmentSpread",
						"name": {
							"kind": "Name",
							"value": "OrganizationNameFragment"
						}
					},
					{
						"kind": "FragmentSpread",
						"name": {
							"kind": "Name",
							"value": "OrganizationMemberListFragment"
						}
					},
					{
						"kind": "FragmentSpread",
						"name": {
							"kind": "Name",
							"value": "OrganizationInviteListFragment"
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationMemberFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "OrganizationMembers"
				}
			},
			"directives": [{
				"kind": "Directive",
				"name": {
					"kind": "Name",
					"value": "_unmask"
				}
			}],
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "role"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "profileId"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "profile"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "avatarUrl"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "name"
									}
								}
							]
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationNameFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "name"
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationMemberListFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"alias": {
							"kind": "Name",
							"value": "members"
						},
						"name": {
							"kind": "Name",
							"value": "organizationMembersCollection"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "edges"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									}, {
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "node"
										},
										"selectionSet": {
											"kind": "SelectionSet",
											"selections": [
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "__typename"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "id"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "profileId"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "role"
													}
												},
												{
													"kind": "FragmentSpread",
													"name": {
														"kind": "Name",
														"value": "OrganizationMemberFragment"
													}
												}
											]
										}
									}]
								}
							}]
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationInviteListFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"alias": {
							"kind": "Name",
							"value": "invites"
						},
						"name": {
							"kind": "Name",
							"value": "organizationInvitationsCollection"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "edges"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									}, {
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "node"
										},
										"selectionSet": {
											"kind": "SelectionSet",
											"selections": [
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "__typename"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "id"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "createdAt"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "role"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "status"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "email"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "invitationOwnerProfile"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "__typename"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "name"
																}
															}
														]
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "invitedProfile"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "__typename"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "name"
																}
															}
														]
													}
												}
											]
										}
									}]
								}
							}]
						}
					}
				]
			}
		}
	]
};
var StripeAccountDetailsFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "StripeAccountDetailsFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "ApiStripeConnectedAccountResultSuccess"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "stripeAccountId"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "stripeAccount"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "email"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "country"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "defaultCurrency"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "detailsSubmitted"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "capabilities"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "cardPayments"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "usBankTransfers"
											}
										}
									]
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "businessProfile"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "name"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "url"
											}
										}
									]
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "created"
								}
							}
						]
					}
				}
			]
		}
	}]
};
var StripeAccountFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "StripeAccountFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "ApiStripeConnectedAccountResult"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "InlineFragment",
					"typeCondition": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "ApiStripeConnectedAccountResultNotSetup"
						}
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						}, {
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "message"
							}
						}]
					}
				},
				{
					"kind": "InlineFragment",
					"typeCondition": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "ApiStripeConnectedAccountResultSuccess"
						}
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "stripeAccountId"
								}
							},
							{
								"kind": "FragmentSpread",
								"name": {
									"kind": "Name",
									"value": "StripeAccountDetailsFragment"
								}
							}
						]
					}
				}
			]
		}
	}, {
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "StripeAccountDetailsFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "ApiStripeConnectedAccountResultSuccess"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "stripeAccountId"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "stripeAccount"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "id"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "email"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "country"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "defaultCurrency"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "detailsSubmitted"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "capabilities"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "cardPayments"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "usBankTransfers"
											}
										}
									]
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "businessProfile"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "name"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "url"
											}
										}
									]
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "created"
								}
							}
						]
					}
				}
			]
		}
	}]
};
var MyOrganizationsFragmentFragmentDoc = {
	"kind": "Document",
	"definitions": [{
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "MyOrganizationsFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "Profiles"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "id"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "organizationMembersCollection"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						}, {
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "edges"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								}, {
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "node"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "organization"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "__typename"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "id"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "name"
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}
			]
		}
	}]
};
var AcceptInvitationDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "AcceptInvitation"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "id"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "apiAcceptOrganizationInvitation"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "invitationId"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "organizationId"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "invitationId"
							}
						}
					]
				}
			}]
		}
	}]
};
var DeleteInvitationDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "DeleteInvitation"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "id"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "deleteFromOrganizationInvitationsCollection"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "filter"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "id"
							},
							"value": {
								"kind": "ObjectValue",
								"fields": [{
									"kind": "ObjectField",
									"name": {
										"kind": "Name",
										"value": "eq"
									},
									"value": {
										"kind": "Variable",
										"name": {
											"kind": "Name",
											"value": "id"
										}
									}
								}]
							}
						}]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "affectedCount"
						}
					}]
				}
			}]
		}
	}]
};
var CreateOrganizationDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "CreateOrganization"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "name"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "String"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "apiCreateOrganization"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "org"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "name"
							},
							"value": {
								"kind": "Variable",
								"name": {
									"kind": "Name",
									"value": "name"
								}
							}
						}]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}]
				}
			}]
		}
	}]
};
var MyOrgsDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "MyOrgs"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "id"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}, {
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "email"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "String"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "organizationMembersCollection"
					},
					"arguments": [{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "filter"
						},
						"value": {
							"kind": "ObjectValue",
							"fields": [{
								"kind": "ObjectField",
								"name": {
									"kind": "Name",
									"value": "profileId"
								},
								"value": {
									"kind": "ObjectValue",
									"fields": [{
										"kind": "ObjectField",
										"name": {
											"kind": "Name",
											"value": "eq"
										},
										"value": {
											"kind": "Variable",
											"name": {
												"kind": "Name",
												"value": "id"
											}
										}
									}]
								}
							}]
						}
					}],
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						}, {
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "edges"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								}, {
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "node"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "organization"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "__typename"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "name"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "id"
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "organizationInvitationsCollection"
					},
					"arguments": [{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "filter"
						},
						"value": {
							"kind": "ObjectValue",
							"fields": [{
								"kind": "ObjectField",
								"name": {
									"kind": "Name",
									"value": "email"
								},
								"value": {
									"kind": "ObjectValue",
									"fields": [{
										"kind": "ObjectField",
										"name": {
											"kind": "Name",
											"value": "eq"
										},
										"value": {
											"kind": "Variable",
											"name": {
												"kind": "Name",
												"value": "email"
											}
										}
									}]
								}
							}, {
								"kind": "ObjectField",
								"name": {
									"kind": "Name",
									"value": "status"
								},
								"value": {
									"kind": "ObjectValue",
									"fields": [{
										"kind": "ObjectField",
										"name": {
											"kind": "Name",
											"value": "eq"
										},
										"value": {
											"kind": "EnumValue",
											"value": "pending"
										}
									}]
								}
							}]
						}
					}],
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "FragmentSpread",
								"name": {
									"kind": "Name",
									"value": "MyPendingInviteListFragment"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "edges"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									}, {
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "node"
										},
										"selectionSet": {
											"kind": "SelectionSet",
											"selections": [{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											}, {
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											}]
										}
									}]
								}
							}
						]
					}
				}
			]
		}
	}, {
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "MyPendingInviteListFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "OrganizationInvitationsConnection"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "edges"
				},
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "node"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "organization"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "role"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "status"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "createdAt"
									}
								}
							]
						}
					}]
				}
			}]
		}
	}]
};
var ApiRecordFrontendMetricsDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "ApiRecordFrontendMetrics"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "metrics"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "ListType",
					"type": {
						"kind": "NonNullType",
						"type": {
							"kind": "NamedType",
							"name": {
								"kind": "Name",
								"value": "FrontendMetricInput"
							}
						}
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "apiRecordFrontendMetrics"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "metrics"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "metrics"
						}
					}
				}]
			}]
		}
	}]
};
var MyOrganizationsQueryDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "MyOrganizationsQuery"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "id"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "profilesCollection"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "filter"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "id"
							},
							"value": {
								"kind": "ObjectValue",
								"fields": [{
									"kind": "ObjectField",
									"name": {
										"kind": "Name",
										"value": "eq"
									},
									"value": {
										"kind": "Variable",
										"name": {
											"kind": "Name",
											"value": "id"
										}
									}
								}]
							}
						}]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "edges"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "node"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "id"
											}
										},
										{
											"kind": "FragmentSpread",
											"name": {
												"kind": "Name",
												"value": "MyOrganizationsFragment"
											}
										}
									]
								}
							}]
						}
					}]
				}
			}]
		}
	}, {
		"kind": "FragmentDefinition",
		"name": {
			"kind": "Name",
			"value": "MyOrganizationsFragment"
		},
		"typeCondition": {
			"kind": "NamedType",
			"name": {
				"kind": "Name",
				"value": "Profiles"
			}
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "id"
					}
				},
				{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "organizationMembersCollection"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						}, {
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "edges"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								}, {
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "node"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "organization"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "__typename"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "id"
															}
														},
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "name"
															}
														}
													]
												}
											}
										]
									}
								}]
							}
						}]
					}
				}
			]
		}
	}]
};
var GetStripePlansDocument = {
	"kind": "Document",
	"definitions": [
		{
			"kind": "OperationDefinition",
			"operation": "query",
			"name": {
				"kind": "Name",
				"value": "GetStripePlans"
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				}, {
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "apiSubscriptionPlans"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "plans"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									}, {
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "id"
										}
									}]
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "FragmentSpread",
								"name": {
									"kind": "Name",
									"value": "PricingTableFragment"
								}
							}
						]
					}
				}]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "PricingCardFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "ApiSubscriptionPlan"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "description"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "name"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "prices"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "amountCents"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "currency"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "stripePriceId"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "recurring"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "interval"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "intervalCount"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "trialPeriodDays"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "billingScheme"
												},
												"selectionSet": {
													"kind": "SelectionSet",
													"selections": [
														{
															"kind": "Field",
															"name": {
																"kind": "Name",
																"value": "__typename"
															}
														},
														{
															"kind": "InlineFragment",
															"typeCondition": {
																"kind": "NamedType",
																"name": {
																	"kind": "Name",
																	"value": "ApiSubscriptionPlanPriceBillingSchemePerUnit"
																}
															},
															"selectionSet": {
																"kind": "SelectionSet",
																"selections": [{
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "__typename"
																	}
																}, {
																	"kind": "Field",
																	"name": {
																		"kind": "Name",
																		"value": "usageType"
																	}
																}]
															}
														},
														{
															"kind": "InlineFragment",
															"typeCondition": {
																"kind": "NamedType",
																"name": {
																	"kind": "Name",
																	"value": "ApiSubscriptionPlanPriceBillingSchemeTiered"
																}
															},
															"selectionSet": {
																"kind": "SelectionSet",
																"selections": [
																	{
																		"kind": "Field",
																		"name": {
																			"kind": "Name",
																			"value": "__typename"
																		}
																	},
																	{
																		"kind": "Field",
																		"name": {
																			"kind": "Name",
																			"value": "tiersMode"
																		}
																	},
																	{
																		"kind": "Field",
																		"name": {
																			"kind": "Name",
																			"value": "tiers"
																		},
																		"selectionSet": {
																			"kind": "SelectionSet",
																			"selections": [
																				{
																					"kind": "Field",
																					"name": {
																						"kind": "Name",
																						"value": "__typename"
																					}
																				},
																				{
																					"kind": "Field",
																					"name": {
																						"kind": "Name",
																						"value": "flatAmountCents"
																					}
																				},
																				{
																					"kind": "Field",
																					"name": {
																						"kind": "Name",
																						"value": "unitAmountCents"
																					}
																				},
																				{
																					"kind": "Field",
																					"name": {
																						"kind": "Name",
																						"value": "upTo"
																					}
																				}
																			]
																		}
																	}
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "PricingTableFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "ApiSubscriptionPlanResult"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				}, {
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "plans"
					},
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "description"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "name"
								}
							},
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "prices"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									}, {
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "id"
										}
									}]
								}
							},
							{
								"kind": "FragmentSpread",
								"name": {
									"kind": "Name",
									"value": "PricingCardFragment"
								}
							}
						]
					}
				}]
			}
		}
	]
};
var CreateCheckoutSessionDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "CreateCheckoutSession"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "ApiCreateSubscriptionCheckoutSessionInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "apiCreateOrganizationSubscriptionCheckoutSession"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "url"
						}
					}]
				}
			}]
		}
	}]
};
var QueryErrorTestDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "QueryErrorTest"
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "queryErrorTest"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "message"
					},
					"value": {
						"kind": "StringValue",
						"value": "This is a test error",
						"block": false
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "value"
						}
					}]
				}
			}]
		}
	}]
};
var UpdateNameDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "UpdateName"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "name"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "String"
					}
				}
			}
		}, {
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "organizationId"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "updateOrganizationsCollection"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "set"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "name"
							},
							"value": {
								"kind": "Variable",
								"name": {
									"kind": "Name",
									"value": "name"
								}
							}
						}]
					}
				}, {
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "filter"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "id"
							},
							"value": {
								"kind": "ObjectValue",
								"fields": [{
									"kind": "ObjectField",
									"name": {
										"kind": "Name",
										"value": "eq"
									},
									"value": {
										"kind": "Variable",
										"name": {
											"kind": "Name",
											"value": "organizationId"
										}
									}
								}]
							}
						}]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "records"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "name"
								}
							}]
						}
					}]
				}
			}]
		}
	}]
};
var UpdateInvitationDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "UpdateInvitation"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "id"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "deleteFromOrganizationInvitationsCollection"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "filter"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "id"
							},
							"value": {
								"kind": "ObjectValue",
								"fields": [{
									"kind": "ObjectField",
									"name": {
										"kind": "Name",
										"value": "eq"
									},
									"value": {
										"kind": "Variable",
										"name": {
											"kind": "Name",
											"value": "id"
										}
									}
								}]
							}
						}]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "affectedCount"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}]
				}
			}]
		}
	}]
};
var NewInvitationDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "NewInvitation"
		},
		"variableDefinitions": [
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "email"
					}
				},
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "String"
						}
					}
				}
			},
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "organizationId"
					}
				},
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "UUID"
						}
					}
				}
			},
			{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "role"
					}
				},
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "OrganizationMemberRole"
						}
					}
				}
			}
		],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "apiCreateOrganizationInvitation"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [
							{
								"kind": "ObjectField",
								"name": {
									"kind": "Name",
									"value": "email"
								},
								"value": {
									"kind": "Variable",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								}
							},
							{
								"kind": "ObjectField",
								"name": {
									"kind": "Name",
									"value": "organizationId"
								},
								"value": {
									"kind": "Variable",
									"name": {
										"kind": "Name",
										"value": "organizationId"
									}
								}
							},
							{
								"kind": "ObjectField",
								"name": {
									"kind": "Name",
									"value": "role"
								},
								"value": {
									"kind": "Variable",
									"name": {
										"kind": "Name",
										"value": "role"
									}
								}
							}
						]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "invitationId"
						}
					}]
				}
			}]
		}
	}]
};
var OrganizationQueryDocument = {
	"kind": "Document",
	"definitions": [
		{
			"kind": "OperationDefinition",
			"operation": "query",
			"name": {
				"kind": "Name",
				"value": "OrganizationQuery"
			},
			"variableDefinitions": [{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "orgId"
					}
				},
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "UUID"
						}
					}
				}
			}],
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				}, {
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "organizationsCollection"
					},
					"arguments": [{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "filter"
						},
						"value": {
							"kind": "ObjectValue",
							"fields": [{
								"kind": "ObjectField",
								"name": {
									"kind": "Name",
									"value": "id"
								},
								"value": {
									"kind": "ObjectValue",
									"fields": [{
										"kind": "ObjectField",
										"name": {
											"kind": "Name",
											"value": "eq"
										},
										"value": {
											"kind": "Variable",
											"name": {
												"kind": "Name",
												"value": "orgId"
											}
										}
									}]
								}
							}]
						}
					}],
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						}, {
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "edges"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								}, {
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "node"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "id"
												}
											},
											{
												"kind": "FragmentSpread",
												"name": {
													"kind": "Name",
													"value": "OrganizationPageFragment"
												}
											}
										]
									}
								}]
							}
						}]
					}
				}]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationNameFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "name"
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationMemberFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "OrganizationMembers"
				}
			},
			"directives": [{
				"kind": "Directive",
				"name": {
					"kind": "Name",
					"value": "_unmask"
				}
			}],
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "role"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "profileId"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "profile"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "avatarUrl"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "name"
									}
								}
							]
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationMemberListFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"alias": {
							"kind": "Name",
							"value": "members"
						},
						"name": {
							"kind": "Name",
							"value": "organizationMembersCollection"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "edges"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									}, {
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "node"
										},
										"selectionSet": {
											"kind": "SelectionSet",
											"selections": [
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "__typename"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "id"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "profileId"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "role"
													}
												},
												{
													"kind": "FragmentSpread",
													"name": {
														"kind": "Name",
														"value": "OrganizationMemberFragment"
													}
												}
											]
										}
									}]
								}
							}]
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationInviteListFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "Field",
						"alias": {
							"kind": "Name",
							"value": "invites"
						},
						"name": {
							"kind": "Name",
							"value": "organizationInvitationsCollection"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "edges"
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									}, {
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "node"
										},
										"selectionSet": {
											"kind": "SelectionSet",
											"selections": [
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "__typename"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "id"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "createdAt"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "role"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "status"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "email"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "invitationOwnerProfile"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "__typename"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "name"
																}
															}
														]
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "invitedProfile"
													},
													"selectionSet": {
														"kind": "SelectionSet",
														"selections": [
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "__typename"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "id"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "email"
																}
															},
															{
																"kind": "Field",
																"name": {
																	"kind": "Name",
																	"value": "name"
																}
															}
														]
													}
												}
											]
										}
									}]
								}
							}]
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "OrganizationPageFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "Organizations"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "id"
						}
					},
					{
						"kind": "FragmentSpread",
						"name": {
							"kind": "Name",
							"value": "OrganizationNameFragment"
						}
					},
					{
						"kind": "FragmentSpread",
						"name": {
							"kind": "Name",
							"value": "OrganizationMemberListFragment"
						}
					},
					{
						"kind": "FragmentSpread",
						"name": {
							"kind": "Name",
							"value": "OrganizationInviteListFragment"
						}
					}
				]
			}
		}
	]
};
var PingMyDateDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "PingMyDate"
		},
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "pingDt"
				},
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "dt"
						}
					}]
				}
			}]
		}
	}]
};
var GetStripeAccountDocument = {
	"kind": "Document",
	"definitions": [
		{
			"kind": "OperationDefinition",
			"operation": "query",
			"name": {
				"kind": "Name",
				"value": "GetStripeAccount"
			},
			"variableDefinitions": [{
				"kind": "VariableDefinition",
				"variable": {
					"kind": "Variable",
					"name": {
						"kind": "Name",
						"value": "orgId"
					}
				},
				"type": {
					"kind": "NonNullType",
					"type": {
						"kind": "NamedType",
						"name": {
							"kind": "Name",
							"value": "UUID"
						}
					}
				}
			}],
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [{
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "__typename"
					}
				}, {
					"kind": "Field",
					"name": {
						"kind": "Name",
						"value": "apiStripeConnectSubscription"
					},
					"arguments": [{
						"kind": "Argument",
						"name": {
							"kind": "Name",
							"value": "organizationId"
						},
						"value": {
							"kind": "Variable",
							"name": {
								"kind": "Name",
								"value": "orgId"
							}
						}
					}],
					"selectionSet": {
						"kind": "SelectionSet",
						"selections": [
							{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							},
							{
								"kind": "FragmentSpread",
								"name": {
									"kind": "Name",
									"value": "StripeAccountFragment"
								}
							},
							{
								"kind": "InlineFragment",
								"typeCondition": {
									"kind": "NamedType",
									"name": {
										"kind": "Name",
										"value": "ApiStripeConnectedAccountResultSuccess"
									}
								},
								"selectionSet": {
									"kind": "SelectionSet",
									"selections": [
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "__typename"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "stripeAccountId"
											}
										},
										{
											"kind": "Field",
											"name": {
												"kind": "Name",
												"value": "stripeAccount"
											},
											"selectionSet": {
												"kind": "SelectionSet",
												"selections": [{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "__typename"
													}
												}, {
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "dashboardUrl"
													}
												}]
											}
										}
									]
								}
							}
						]
					}
				}]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "StripeAccountDetailsFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "ApiStripeConnectedAccountResultSuccess"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "stripeAccountId"
						}
					},
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "stripeAccount"
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "id"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "email"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "country"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "defaultCurrency"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "detailsSubmitted"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "capabilities"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "cardPayments"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "usBankTransfers"
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "businessProfile"
									},
									"selectionSet": {
										"kind": "SelectionSet",
										"selections": [
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "__typename"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "name"
												}
											},
											{
												"kind": "Field",
												"name": {
													"kind": "Name",
													"value": "url"
												}
											}
										]
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "created"
									}
								}
							]
						}
					}
				]
			}
		},
		{
			"kind": "FragmentDefinition",
			"name": {
				"kind": "Name",
				"value": "StripeAccountFragment"
			},
			"typeCondition": {
				"kind": "NamedType",
				"name": {
					"kind": "Name",
					"value": "ApiStripeConnectedAccountResult"
				}
			},
			"selectionSet": {
				"kind": "SelectionSet",
				"selections": [
					{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					},
					{
						"kind": "InlineFragment",
						"typeCondition": {
							"kind": "NamedType",
							"name": {
								"kind": "Name",
								"value": "ApiStripeConnectedAccountResultNotSetup"
							}
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [{
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "__typename"
								}
							}, {
								"kind": "Field",
								"name": {
									"kind": "Name",
									"value": "message"
								}
							}]
						}
					},
					{
						"kind": "InlineFragment",
						"typeCondition": {
							"kind": "NamedType",
							"name": {
								"kind": "Name",
								"value": "ApiStripeConnectedAccountResultSuccess"
							}
						},
						"selectionSet": {
							"kind": "SelectionSet",
							"selections": [
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "__typename"
									}
								},
								{
									"kind": "Field",
									"name": {
										"kind": "Name",
										"value": "stripeAccountId"
									}
								},
								{
									"kind": "FragmentSpread",
									"name": {
										"kind": "Name",
										"value": "StripeAccountDetailsFragment"
									}
								}
							]
						}
					}
				]
			}
		}
	]
};
var CreateConnectedAccountDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "CreateConnectedAccount"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "organizationId"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "apiCreateConnectedAccountForOrganization"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "organizationId"
							},
							"value": {
								"kind": "Variable",
								"name": {
									"kind": "Name",
									"value": "organizationId"
								}
							}
						}]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "stripeOnBoardingLink"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "stripeAccountId"
							}
						}
					]
				}
			}]
		}
	}]
};
var DeleteOrgStripeAccountDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "DeleteOrgStripeAccount"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "organizationId"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "UUID"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "deleteFromOrganizationStripeAccountsCollection"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "filter"
					},
					"value": {
						"kind": "ObjectValue",
						"fields": [{
							"kind": "ObjectField",
							"name": {
								"kind": "Name",
								"value": "id"
							},
							"value": {
								"kind": "ObjectValue",
								"fields": [{
									"kind": "ObjectField",
									"name": {
										"kind": "Name",
										"value": "eq"
									},
									"value": {
										"kind": "Variable",
										"name": {
											"kind": "Name",
											"value": "organizationId"
										}
									}
								}]
							}
						}]
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [{
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "__typename"
						}
					}, {
						"kind": "Field",
						"name": {
							"kind": "Name",
							"value": "affectedCount"
						}
					}]
				}
			}]
		}
	}]
};
var SetOauthRefreshTokenDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "mutation",
		"name": {
			"kind": "Name",
			"value": "SetOauthRefreshToken"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "input"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "SaveRefreshTokenInput"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "saveRefreshToken"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "input"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "input"
						}
					}
				}]
			}]
		}
	}]
};
var AttrsDocument = {
	"kind": "Document",
	"definitions": [{
		"kind": "OperationDefinition",
		"operation": "query",
		"name": {
			"kind": "Name",
			"value": "attrs"
		},
		"variableDefinitions": [{
			"kind": "VariableDefinition",
			"variable": {
				"kind": "Variable",
				"name": {
					"kind": "Name",
					"value": "bbox"
				}
			},
			"type": {
				"kind": "NonNullType",
				"type": {
					"kind": "NamedType",
					"name": {
						"kind": "Name",
						"value": "BBox"
					}
				}
			}
		}],
		"selectionSet": {
			"kind": "SelectionSet",
			"selections": [{
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "__typename"
				}
			}, {
				"kind": "Field",
				"name": {
					"kind": "Name",
					"value": "ApiAttributesForBoundingBox"
				},
				"arguments": [{
					"kind": "Argument",
					"name": {
						"kind": "Name",
						"value": "boundingBox"
					},
					"value": {
						"kind": "Variable",
						"name": {
							"kind": "Name",
							"value": "bbox"
						}
					}
				}],
				"selectionSet": {
					"kind": "SelectionSet",
					"selections": [
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "__typename"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "tileIds"
							}
						},
						{
							"kind": "Field",
							"name": {
								"kind": "Name",
								"value": "mapLines"
							},
							"selectionSet": {
								"kind": "SelectionSet",
								"selections": [
									{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "__typename"
										}
									},
									{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "id"
										}
									},
									{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "coords"
										},
										"selectionSet": {
											"kind": "SelectionSet",
											"selections": [
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "__typename"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "lat"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "lng"
													}
												}
											]
										}
									},
									{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "style"
										},
										"selectionSet": {
											"kind": "SelectionSet",
											"selections": [
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "__typename"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "color"
													}
												},
												{
													"kind": "Field",
													"name": {
														"kind": "Name",
														"value": "width"
													}
												}
											]
										}
									},
									{
										"kind": "Field",
										"name": {
											"kind": "Name",
											"value": "tooltip"
										}
									}
								]
							}
						}
					]
				}
			}]
		}
	}]
};
//#endregion
export { AcceptInvitationDocument, ApiRecordFrontendMetricsDocument, AttrsDocument, CreateCheckoutSessionDocument, CreateConnectedAccountDocument, CreateOrganizationDocument, DeleteInvitationDocument, DeleteOrgStripeAccountDocument, GetStripeAccountDocument, GetStripePlansDocument, MyOrganizationsFragmentFragmentDoc, MyOrganizationsQueryDocument, MyOrgsDocument, MyPendingInviteListFragmentFragmentDoc, NewInvitationDocument, OrganizationInviteListFragmentFragmentDoc, OrganizationMemberFragmentFragmentDoc, OrganizationMemberListFragmentFragmentDoc, OrganizationNameFragmentFragmentDoc, OrganizationPageFragmentFragmentDoc, OrganizationQueryDocument, PingMyDateDocument, PricingCardFragmentFragmentDoc, PricingTableFragmentFragmentDoc, QueryErrorTestDocument, SetOauthRefreshTokenDocument, StripeAccountDetailsFragmentFragmentDoc, StripeAccountFragmentFragmentDoc, UpdateInvitationDocument, UpdateNameDocument };

//# sourceMappingURL=graphql.js.map